import React from 'react';
import cn from 'classnames';

import {isTranslate} from 'shared/lib/lang';

import styles from './SpinnerWithOverlay.module.scss';

interface ISpinnerWithOverlayProps {
    overlay?: boolean;
    className?: string;
}

const SpinnerWithOverlay: React.FC<ISpinnerWithOverlayProps> = ({overlay = true, className}) => {
    return (
        <div className={cn(styles['spinner-overlay'], overlay ? styles.overlay : styles.inline, className)}>
            <div className={cn(styles.spinner, styles.doubleBounce)}>
                <div className={cn(styles.bounce1, isTranslate() && styles.ebBackground)}/>
                <div className={cn(styles.bounce2, isTranslate() && styles.ebBackground)}/>
            </div>
        </div>
    );
};

export default SpinnerWithOverlay;
